"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Fredag",
    "MONDAY": "Mandag",
    "SATURDAY": "Lørdag",
    "SUNDAY": "Søndag",
    "THURSDAY": "Torsdag",
    "TUESDAY": "Tirsdag",
    "WEDNESDAY": "Onsdag",
    "and": "og",
    "day": "dag",
    "day_one": "dag",
    "day_other": "dager",
    "day_plural": "dager",
    "freeOfCharge": "Gratis",
    "hour_one": "time",
    "hour_one_plural": "timer",
    "hour_other": "timer",
    "minute": "minutt",
    "minute_one": "minutt",
    "minute_other": "minutter",
    "ocpiRestrictionsAfterDuration": "Etter {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Mellom {{minDuration}} og {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Første {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Ved strømforbruk over {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Ved strømforbruk mellom {{minKwh}} og {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Ved strømforbruk lavere enn {{maxKwh}}",
    "session": "ladeøkt",
    "theDay": "dag",
    "theDay_one": "dag",
    "theDay_other": "dager",
    "theHour": "time",
    "theHour_one": "time",
    "theHour_other": "timer",
    "theMinute": "minutt",
    "theMinute_one": "minutt",
    "theMinute_other": "minutter"
};
